import React from 'react';
import { CreditCard, XCircle } from 'lucide-react';
interface PaymentProblemBannerProps {
  message: string;
  onUpdatePaymentMethod: () => void;
}

// Warning under the contact header when the card on file is expired or failing.
// Matches the PaymentStatusBanner treatment used on subscriptions.
export function PaymentProblemBanner({
  message,
  onUpdatePaymentMethod
}: PaymentProblemBannerProps) {
  return <div role="alert" className="bg-[#FEE2E2] border-l-4 border-l-[#EF4444] rounded-lg p-4 mb-6" data-id="element-1693" data-mp="24dgjm9l0k23i">
      <div className="flex flex-col sm:flex-row sm:items-center gap-4" data-id="element-1694" data-mp="1zggdxzs2t1cx">
        <div className="flex items-start gap-4 flex-1 min-w-0" data-id="element-1695" data-mp="1ug25igmkbped">
          <XCircle className="w-5 h-5 text-[#EF4444] flex-shrink-0 mt-0.5" data-id="element-1696" data-mp="1uieuveunh21g" />
          <div className="min-w-0" data-id="element-1697" data-mp="1pgft29ek6d6m">
            <h3 className="text-[16px] font-semibold text-[#0F172A] mb-1" data-id="element-1698" data-mp="1pjldhbc8sqw0">
              Payment problem
            </h3>
            <p className="text-[14px] text-[#475569]" data-id="element-1699" data-mp="e1kdml8387p0">{message}</p>
          </div>
        </div>
        <button type="button" onClick={onUpdatePaymentMethod} className="inline-flex items-center justify-center gap-2 h-10 px-4 bg-[#0EA5E9] border border-[#0EA5E9] rounded-md text-white text-[14px] font-medium hover:bg-[#0284C7] hover:border-[#0284C7] focus:outline-none focus:ring-2 focus:ring-[#0EA5E9] focus:ring-opacity-20 transition-all flex-shrink-0" data-id="element-1700" data-mp="1yz2s6y66qn0l">
          <CreditCard className="w-4 h-4" data-id="element-1701" data-mp="1txvkt07yfpug" />
          Update payment method
        </button>
      </div>
    </div>;
}